// Raw refresh call. Lives outside client.js so the 401 handler can call it
// without recursing through its own response interceptor.
import { getRuntimeApiKey } from '@core/store/runtimeApiStore';
import { env } from '@config/env';
import { endpoints } from './endpoints.js';
import { normalizeError } from './errors.js';

/**
 * @param {string} refreshToken
 * @returns {Promise<{ access_token: string, refresh_token: string, expires_in: number, token_type: string }>}
 */
export async function refreshTokenRequest(refreshToken) {
  const apiKey = getRuntimeApiKey() || env.apiKey;
  const headers = { 'Content-Type': 'application/json' };
  if (apiKey) headers.Authorization = `ApiKey ${apiKey}`;

  let response;
  try {
    response = await fetch(`${env.apiBaseUrl}${endpoints.auth.refresh}`, {
      method: 'POST',
      headers,
      body: JSON.stringify({ refresh_token: refreshToken }),
    });
  } catch (err) {
    throw normalizeError(err);
  }

  let body = null;
  const ct = response.headers.get('content-type') || '';
  if (ct.includes('application/json')) {
    body = await response.json().catch(() => null);
  }

  if (!response.ok) {
    throw normalizeError({ status: response.status, body });
  }
  return body?.data && typeof body.data === 'object' ? body.data : body;
}
